import React from 'react'

import { CheckboxIconProps } from '@chakra-ui/react'

export const CheckboxIcon: React.FC<CheckboxIconProps> = ({
  __css,
  isChecked,
}) => {
  return isChecked ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        d="M4 9.84L7.18105 14.2935C7.75661 15.0993 8.96951 15.0508 9.47898 14.2017L15 5"
        stroke={String(__css?.color)}
        strokeWidth="2"
      />
    </svg>
  ) : null
}
